import { css } from '@emotion/core';

import { colors } from '../../../configs';

export const iconStyles = css`
  font-size: 20px;
  color: ${colors.KODE_DARK_GREY};
`;
